import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { getGoogleMapsUrl } from 'site-modules/shared/utils/dealer-details-utils';
import { DealerFiveStarAwards } from 'site-modules/dealerships/components/dealer-five-star-awards/dealer-five-star-awards';

import './dealer-carousel-slide.scss';

function DealerCarouselSlideUI(props) {
  const { photoUrl, dealerName, fiveStarDealerAward, slideNumber, isDefaultSlide, isMobile, address } = props;
  return (
    <div className="dealer-carousel-slide">
      <div
        className={classNames('photo', { 'default-photo': isDefaultSlide })}
        style={{ backgroundImage: `url('${photoUrl}')` }}
      />
      {slideNumber === 0 && (
        <div className="slide-content text-zdepth-1 py-1_5 px-0_5 px-md-1 w-100">
          <div className="container mt-1 mt-lg-3 pt-lg-2 hidden-md-down">
            <DealerFiveStarAwards
              years={fiveStarDealerAward}
              className="px-md-1 pt-md-1 pb-md-0_5 px-2 d-inline-block mb-0_5"
              whiteLogo
            />
            <h1 className="display-1 text-white text-zdepth-1 fw-bold">{dealerName}</h1>
          </div>
          <div className="display-1 text-white text-zdepth-1 fw-bold hidden-md-up">{dealerName}</div>
          {address && isMobile && (
            <Row className="dealer-location-wrapper">
              <Col xs={8}>
                <div className="dealer-location h5 fw-normal">
                  <a
                    href={getGoogleMapsUrl(address)}
                    rel="noopener noreferrer nofollow"
                    data-tracking-id="ddp_view_dealer_hours_and_directions"
                    className="dealer-location-link ms-0_25"
                    target="_blank"
                  >
                    {address.street}, {address.city}, {address.stateCode}&nbsp;{address.zip}
                  </a>
                </div>
              </Col>
            </Row>
          )}
        </div>
      )}
    </div>
  );
}

DealerCarouselSlideUI.propTypes = {
  dealerName: PropTypes.string,
  slideNumber: PropTypes.number,
  photoUrl: PropTypes.string,
  address: PropTypes.shape({
    city: PropTypes.string,
    stateCode: PropTypes.string,
    stateName: PropTypes.string,
    street: PropTypes.string,
    zip: PropTypes.string,
  }),
  fiveStarDealerAward: PropTypes.arrayOf(PropTypes.number),
  isDefaultSlide: PropTypes.bool,
  isMobile: PropTypes.bool,
};

DealerCarouselSlideUI.defaultProps = {
  dealerName: '',
  slideNumber: 0,
  photoUrl: '',
  address: null,
  fiveStarDealerAward: [],
  isDefaultSlide: false,
  isMobile: false,
};

export const mapStateToProps = state => ({ isMobile: state.mobile });

export const DealerCarouselSlide = connect(mapStateToProps)(DealerCarouselSlideUI);
